// https://api.holdstation.com/api/coins/chain/324/aigentfi?limit=200&page=1

import { request } from "@/utils/request";
import useSWR from "swr";

interface DataAiAgentFI {
  id: number;
  symbol: string;
  name: string;
  address: string;
  coinGeckoId: string;
  verified: boolean;
  iconUrl: string;
  type: any | null;
  decimals: number;
  category: string[];
  volume24h: number;
  verifiedAt: null;
  price: number;
  change24h: number;
  marketCap: number;
  description: string;
  holder: string | null;
  createdAt: string;
}

interface ResponseAiAgentFI {
  page: number;
  size: number;
  totalPage: number;
  totalCount: number;
  data: DataAiAgentFI[] | null;
}

async function fetchAIAgentFi(url: string) {
  const response = await request(url);
  const data = await response.json();
  return data as ResponseAiAgentFI;
}

export function useAIAgentFi() {
  const data = useSWR("https://api.holdstation.com/api/coins/chain/324/aigentfi?limit=200&page=1", fetchAIAgentFi, {
    refreshInterval: 15_000,
    errorRetryInterval: 10_000,
  });

  return data;
}
